var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_640930368"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M9415020 8000165l6291794 -6292066c390910,-390579 390910,-1024323 0,-1414914 -390898,-390921 -1023957,-390921 -1414855,0l-6291794 6292066 -6292137 -6292066c-390898,-390921 -1023945,-390921 -1414855,0 -390898,390579 -390898,1024323 0,1414914l6292137 6292066 -6292137 6292066c-390898,390591 -390898,1024323 0,1414926 195449,195118 451618,292843 707433,292843 255815,0 511973,-97724 707422,-293185l6292137 -6292066 6291806 6292066c195449,195461 451595,293185 707422,293185 255827,0 511985,-97724 707433,-293185 390898,-390579 390898,-1024323 0,-1414914l-6291806 -6291735z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5a83fc9c5941dccf2ae62a97222d80b9.svg";
export { ForwardRef as ReactComponent };